import ReactGA from 'react-ga4';
import {appConfig} from '~/config';

export const initGA = () => {
  if (appConfig.googleAnalytics.isEnable) {
    ReactGA.initialize([
      {
        trackingId: appConfig.googleAnalytics.mdqMeasurementId || '',
        gaOptions: {
          send_page_view: false,
        },
        gtagOptions: {
          send_page_view: false,
        },
      },
      {
        trackingId: appConfig.googleAnalytics.measurementId || '',
        gaOptions: {
          send_page_view: false,
        },
        gtagOptions: {
          send_page_view: false,
        },
      },
    ]);
  }
};

export const trackPageViewGA = (path: string, title: string) => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title,
  });
};
